import React, { useEffect } from "react";
import { useUsers, useProxyLogin, useLoader } from "@piiqtechnologies/ui-lib";
import { Table } from "@components/common/table/Table";
import { UsersTableConfig, sortPredicate } from "./UsersTableConfig";
import { useAuthContext } from "@stores/AuthContext";
import { useIntl } from "react-intl";
import messages from "./messages.i18n";
import UsersActions from "./users-table-actions/UsersActions";
import { USER_ROLES } from "@constants/Roles";
export const UsersTable = ({ onEdit, search, handleUserUpdate }) => {
    const intl = useIntl();
    const usersApi = useUsers();
    const { setLoader } = useLoader();
    const { onLogin } = useAuthContext();
    const [proxyLogin, proxyToken, proxyLoginLoading] = useProxyLogin();
    const handleProxyLogin = (userId) => {
        proxyLogin({ userId });
    };
    useEffect(() => {
        if (!proxyToken)
            return;
        onLogin({ token: proxyToken }, true);
    }, [proxyToken]);
    useEffect(() => {
        setLoader(proxyLoginLoading, "proxyLoginLoading");
        return () => setLoader(false, "proxyLoginLoading");
    }, [proxyLoginLoading]);
    const { usersColumns, userRowTransform, usersParams } = UsersTableConfig({
        debouncedSearchKey: search,
        handleUserUpdate: handleUserUpdate,
    });
    return (React.createElement(Table, { api: usersApi, apiConfig: {
            params: usersParams,
            serverSidePagination: false,
            serverSideSorting: false,
        }, columns: usersColumns, rowTransform: userRowTransform, actionsCover: (row) => UsersActions({
            onObserve: () => handleProxyLogin(row._id),
            onEdit: () => onEdit(row),
            allowProxy: row.status === "active" && row.roleId !== USER_ROLES.Insights,
        }), actions: (row) => UsersActions({
            onObserve: () => handleProxyLogin(row._id),
            onEdit: () => onEdit(row),
            allowProxy: row.status === "active" && row.roleId !== USER_ROLES.Insights,
        }), notFoundMessage: intl.formatMessage(messages.noUsers), sortPredicate: sortPredicate }));
};
export default UsersTable;
